import * as ActionTypes from "constants/ActionTypes";

// `AD_COMPLETED`

export const adCompleted = () => ({
  type: ActionTypes.AD_COMPLETED,
});

// `SET_AD_PLAYING`

export const setAdPlaying = (value) => ({
  type: ActionTypes.SET_AD_PLAYING,
  value,
});

// `SET_AD_DURATION`

export const setAdDuration = (value) => ({
  type: ActionTypes.SET_AD_DURATION,
  value,
});

export const incrementAdTransitions = () => ({
  type: ActionTypes.INCREMENT_AD_TRANSITIONS,
});

export const setAdLoaded = () => ({
  type: ActionTypes.SET_AD_LOADED,
});

// `SET_IS_READY_FOR_AD_RESET`

export const setIsReadyForAdReset = () => ({
  type: ActionTypes.SET_IS_READY_FOR_AD_RESET,
});

export const resetAds = () => ({
  type: ActionTypes.RESET_ADS,
});

// `SET_AD_SKIP_ALLOWED_NOW`

export const setAdSkipAllowedNow = (value) => ({
  type: ActionTypes.SET_AD_SKIP_ALLOWED_NOW,
  value,
});

// `SET_AD_IS_SKIPPABLE`

export const setAdIsSkippable = (value) => ({
  type: ActionTypes.SET_AD_IS_SKIPPABLE,
  value,
});

// `USER_REQUESTED_AD_SKIP`

export const userRequestedAdSkip = () => ({
  type: ActionTypes.USER_REQUESTED_AD_SKIP,
});
